import * as React from 'react';
import { Button, Sizes, Badge } from 'react-bootstrap';
import { RccapStatus } from '@nkr/enums/index';

interface IActionButtonsProps {
    size: Sizes,
    onSave: (status: RccapStatus, sendEmail: boolean) => void,
    onCancel: () => void
}

const ActionButtons = (props: IActionButtonsProps) => {
    const handleSave = (status: RccapStatus, sendEmail: boolean) => {
        props.onSave(status, sendEmail);
    }

    const handleCancel = () => {
        props.onCancel();
    }

    return (
        <>
            <div>
                <Button bsSize={props.size} bsStyle='save-draft' style={{ width: 100, marginRight: 10 }} onClick={() => handleSave(RccapStatus.Draft, false)}><div style={{ paddingTop: 3, paddingBottom: 3 }}>Save<br />Draft</div></Button>
                <Button bsSize={props.size} bsStyle="primary" style={{ marginRight: 10 }} onClick={() => handleSave(RccapStatus.PendingResponse, true)}>Save &amp; Send Email<br /><Badge style={{ backgroundColor: '#EEDE3F', color: "#123", marginTop: 5 }}>Pending Response</Badge></Button>
                <Button bsSize={props.size} bsStyle="primary" style={{ marginRight: 10 }} onClick={() => handleSave(RccapStatus.NeedsMoreInfo, true)}>Save &amp; Send Email<br /><Badge style={{ backgroundColor: '#EEB13F', color: "#123", marginTop: 5 }}>Needs More Info</Badge></Button>
                <Button bsSize={props.size} bsStyle="primary" style={{ marginRight: 10 }} onClick={() => handleSave(RccapStatus.Accepted, true)}>Save &amp; Send Email<br /><Badge style={{ backgroundColor: '#3DAD5C', color: "#FFF", marginTop: 5 }}>Accepted</Badge></Button>
                <Button bsSize={props.size} bsStyle="primary" onClick={() => handleSave(RccapStatus.Accepted, false)}>Save &amp; Don't Send Email<br /><Badge style={{ backgroundColor: '#3DAD5C', color: "#FFF", marginTop: 5 }}>Accepted</Badge></Button>
            </div>

            <Button bsSize={props.size} bsStyle="link" onClick={handleCancel}>Cancel &amp;<br />Return to the RCCAP List</Button>
        </>
    );
}

export default ActionButtons;